import { useState, useEffect } from 'react';
import { cn } from '../../lib/utils';
import { transCls } from '../../const/ui';
import { SolidArrowDownIcon } from '../bs-icons';

const ChevronRightIcon = ({ size }: { size?: number }) => (
  <SolidArrowDownIcon className="-rotate-90" size={size} />
);

export function AppGroupFolder({
  label,
  searchQuery,
  children,
}: {
  label: string;
  searchQuery: string;
  children: React.ReactNode;
}) {
  const [expanded, setExpanded] = useState(true);
  const hasSearch = searchQuery.trim().length > 0;

  useEffect(() => {
    if (hasSearch) {
      setExpanded(true);
    }
  }, [hasSearch]);

  return (
    <div>
      <div
        className={cn(
          'flex items-center gap-[6px] h-[32px] cursor-pointer rounded-[4px] pr-[10px]',
          'hover:bg-[#EFF0F6]',
          'border-b border-[#E0E0E0]',
          'rounded-b-none',
          transCls,
        )}
        style={{ paddingLeft: 10, paddingTop: 9 }}
        onClick={() => setExpanded(!expanded)}
      >
        <span
          className={cn(
            'shrink-0 flex items-center justify-center w-[16px] h-[16px]',
            transCls,
            expanded && 'rotate-90',
          )}
        >
          <ChevronRightIcon size={16} />
        </span>
        <i
          className="icon-bsy-folder-close"
          style={{ fontSize: 16, lineHeight: 1 }}
        />
        <span className="text-[12px] text-[#666666]">{label}</span>
      </div>
      {expanded && (
        <div className="flex flex-col">{children}</div>
      )}
    </div>
  );
}
